import * as ActionTypes from '../../constants/actions';
import { route } from '../../data/data';

export const initialState = {
    active: false,
    from: null,
    to: null,
    viewType: 'map',
    floor: 1,
    path: [],
    accessible: false
}

export default function map(state = initialState, action) {
    const { payload } = action;

    switch (action.type) {
        case ActionTypes.MAP_HIDE:
            return {
                ...state,
                active: false
            }
        break;

        case ActionTypes.MAP_SHOW:
            const { from, to, avoid } = payload;

            const path = route.path(from + '', to + '', {
                avoid: avoid
            });

            return {
                ...state,
                active: true,
                path: path || [],
                floor: null
            }
        break;

        case ActionTypes.MAP_SET_POINT:
            return {
                ...state,
                [payload.type === 'target' ? 'to' : 'from']: payload.id
            }
        break;

        case ActionTypes.MAP_CHANGE_FLOOR:
            return {
                ...state,
                floor: payload.floor
            }
        break;

        case ActionTypes.MAP_CHANGE_ACCESSIBILITY:
            return {
                ...state,
                accessible: payload.value
            }
        break;

        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./reducers/ui/map.js